import { usePostHog as usePH } from "posthog-js/react"
import { useCallback } from "react"

export function usePostHog() {
  const posthog = usePH()

  const captureEvent = useCallback(
    (eventName: string, properties?: Record<string, any>) => {
      if (posthog) {
        posthog.capture(eventName, properties)
      }
    },
    [posthog]
  )

  const identifyUser = useCallback(
    (userId: string, properties?: Record<string, any>) => {
      if (posthog) {
        posthog.identify(userId, properties)
      }
    },
    [posthog]
  )

  const resetUser = useCallback(() => {
    if (posthog) {
      posthog.reset()
    }
  }, [posthog])

  return {
    posthog,
    captureEvent,
    identifyUser,
    resetUser,
  }
}
